export default "assets/eed99cf70afa35b74b6b9e677b625109.png";